import styled from 'styled-components';
import theme from '../../../../../styles/defaultTheme';

export const SpanError = styled.span`
    color: ${(props) => props.theme.red};
    font-size: ${theme.font.size12};
    margin-top: 0px;
    padding-left: 0px;
`;
